import React from "react";
import { Box, Typography } from "@mui/material";
import { Emoji } from "emoji-picker-react";
import AnimatedOrb from "../AnimatedOrb";
import SpeechBubble from "../SpeechBubble";

/**
 * The "ritual" slide — a calming, animated scene.
 * Asks the user which targeted task to tackle first.
 */
const RitualStep = ({ targetTasks, chosenTask, onChooseTask }) => {
  return (
    <Box className="task-guide-step task-guide-step--ritual">
      {/* Animated background particles */}
      <Box className="task-guide-ritual__bg">
        {[...Array(20)].map((_, i) => (
          <Box
            key={i}
            className={`task-guide-ritual__bg-particle task-guide-ritual__bg-particle--${i}`}
          />
        ))}
      </Box>

      <AnimatedOrb size="large" intensity="celebrating" />
      <SpeechBubble>
        <Typography variant="body1" sx={{ margin: 0, textAlign: "center" }}>
          Your targets are all set. Which one would you like to tackle first?
        </Typography>
      </SpeechBubble>

      <Box className="task-guide-ritual__task-list">
        {targetTasks.map((task) => {
          const taskId = task.taskId || task.id;
          const isChosen = chosenTask === taskId;
          return (
            <Box
              key={taskId}
              className={`task-guide-ritual__task-card ${isChosen ? "task-guide-ritual__task-card--chosen" : ""}`}
              onClick={() => onChooseTask(taskId)}
            >
              {task.emoji && (
                <span style={{ display: "flex", alignItems: "center" }}>
                  <Emoji unified={task.emoji} size={20} />
                </span>
              )}
              <Typography
                variant="body1"
                sx={{
                  margin: 0,
                  fontWeight: isChosen ? 700 : 500,
                  color: isChosen ? "#197b68" : "#333",
                }}
              >
                {task.name || task.title}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default RitualStep;
